import { Component, OnInit,ViewChild,ElementRef} from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";


export interface PeriodicElement {
  //position:number;
  COD_DETALLE: string;
  FECHA_TICKET: string;
  DETALLE: number;
  IMPORTE: string;
  CATEGORIA: string;
  OBSERVACIONES: string;
}

var ELEMENT_DATA: PeriodicElement[] = [];

/**
 * @title Table with filtering
 */

@Component({
  selector: 'app-print-gastos',
  templateUrl: './print-gastos.component.html',
  styleUrls: ['./print-gastos.component.css']
})

export class PrintGastosComponent implements OnInit {
  arrayGasto;
  codgas;
  est;
  detalleGasto;
  secdet;
  apellidonombre;
  totgasto;
  //headers
  moti;
  detmoti;
  secc;
  user;
  feccarga;
  loading;

  @ViewChild('TABLE') table: ElementRef;
  displayedColumns: string[] = ['COD_DETALLE', 'FECHA_TICKET', 'DETALLE', 'IMPORTE', 'CATEGORIA', 'OBSERVACIONES'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection = new SelectionModel<PeriodicElement>(true, []);

  constructor(private http: HttpClient) {this.loading=true;}

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Si el número de elementos seleccionados coincide con el número total de filas..
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  //Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
  
  

  ngOnInit() {
    window.scroll(0,0);
    //this.dataSource.data=this.arrayGasto;
    //ELEMENT_DATA.push();
    
    this.codgas=localStorage.getItem('codgasto_edit');
    this.totgasto= localStorage.getItem('imp_gasto');

    this.cargaGrid();
    
    this.detalleGasto = localStorage.getItem('detalleGasto');
    this.secdet = localStorage.getItem('seccdetalle');
    this.apellidonombre = localStorage.getItem('apellidonombre');
    this.arrayGasto=JSON.parse(localStorage.getItem('arrayGastoPrint'));
    
    if (this.arrayGasto){  
      console.log("Array a imprimir..");
      console.log(this.arrayGasto);
    }else{
      console.log("gasto no obtenido..");
    }
    
  }
  registros = 0;

  cargaGrid(){
    this.http.get(`${environment.backendUrl}/api/vergastos/detalle?codgas=${this.codgas}&ima=NO`)
    .subscribe((data: any[]) => {

      console.log("grid cargado..");
      this.dataSource.data = data; 
      console.log(this.dataSource.data);
      this.user = this.dataSource.data[0]["USUARIO"];
      this.secc = this.dataSource.data[0]["SECCIONAL"];
      this.moti = this.dataSource.data[0]["MOTIVO"];
      this.detmoti = this.dataSource.data[0]["DETMOTIVO"];
      this.feccarga = this.dataSource.data[0]["FECHA_CARGA"];
      this.est = this.dataSource.data[0]["ESTADO"];
      this.loading=false; 
      console.log(`${this.dataSource.data.length} ITEMS`);
      this.registros = this.dataSource.data.length;
    });

  }




  onPrint(){
    console.log("printitntin");
    window.print();
}

print2(){
  window.print();
}

print(): void {
  let printContents, popupWin;
  printContents = document.getElementById('print-section').innerHTML;
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  popupWin.document.open();
  popupWin.document.write(`
    <html>
      <head>
        <title>Print tab</title>
        <style>
        //........Customized style.......
        </style>
      </head>
  <body onload="window.print();window.close()">${printContents}</body>
    </html>`
  );
  popupWin.document.close();
}

}
